import React, { useState, useMemo } from "react";
import "./VariantSelector.css";
import { useCart } from "../../Modules/Hooks/useCart";
import { Minus, Plus, X } from "lucide-react";
import API_BASE_URL from "../../config";
import Image from "../Image/Image";

const VariantSelector = ({ product, variants, onClose }) => {
  const [selectedVariant, setSelectedVariant] = useState(variants[0]);
  const [quantity, setQuantity] = useState(1);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(product, selectedVariant, quantity);
    onClose();
  };

  const totalPrice = useMemo(() => {
    return selectedVariant.price * quantity;
  }, [selectedVariant, quantity]);

  return (
    <div className="VariantSelector--Container">
      <div className="VariantSelector--Header">
        <button
          type="button"
          className="VariantSelector--CloseButton"
          onClick={onClose}
          aria-label="Закрыть"
          title="Закрыть"
        >
          <X size={22} />
        </button>
        <Image
          src={`${API_BASE_URL}${product.image_url}`}
          alt={product.product_name}
          className="VariantSelector--Image"
        />
      </div>

      <div className="VariantSelector--Body">
        <h3>{product.product_name}</h3>
        <p className="VariantSelector--Description">{product.composition}</p>

        <div className="VariantSelector--Options">
          <div className="VariantSelector--OptionList">
            {variants.map((variant) => (
              <div
                key={variant.variant_id}
                className={`VariantSelector--OptionItem ${
                  selectedVariant.variant_id === variant.variant_id
                    ? "active"
                    : ""
                }`}
                onClick={() => setSelectedVariant(variant)}
              >
                <div className="VariantSelector--OptionDetails">
                  <span className="VariantSelector--Size">{variant.size}</span>
                  <span className="VariantSelector--Weight">
                    {variant.weight} г
                  </span>
                </div>
                <span className="VariantSelector--Price">
                  {variant.price} ₽
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="VariantSelector--Footer">
        <div className="VariantSelector--Quantity">
          <button
            onClick={() => setQuantity((q) => Math.max(1, q - 1))}
            aria-label="Уменьшить количество"
          >
            <Minus size={20} />
          </button>
          <span>{quantity}</span>
          <button
            onClick={() => setQuantity((q) => q + 1)}
            aria-label="Увеличить количество"
          >
            <Plus size={20} />
          </button>
        </div>
        <button
          className="VariantSelector--AddToCartButton"
          onClick={handleAddToCart}
        >
          Добавить за {totalPrice.toFixed(2)} ₽
        </button>
      </div>
    </div>
  );
};

export default VariantSelector;
